import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!-- @glint-nocheck: this template is not typesafe yet --}}\n<Tools::ImageText::Modal @composer={{@composer}} @onClose={{@onClose}} @onSubmit={{@onInsert}} @isEditing={{false}} data-test-imagetext-inserter />", {
  moduleName: "@intercom/composer-ember/components/tools/image-text-inserter.hbs"
});